import { render } from "./ComponentSettingsHeader.vue?vue&type=template&id=7ad422bf"
import script from "./ComponentSettingsHeader.vue?vue&type=script&lang=js"
export * from "./ComponentSettingsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__